import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { DEFAULT_MICROCOPY, IMAGES } from '../../data/landing';
export function Hero() {
  return <header className="bg-cream" data-id="element-203" data-mp="cu9u4mkjt8th">
      <div className="mx-auto max-w-5xl px-5 pb-14 pt-6 text-center md:pb-20 md:pt-10" data-id="element-204" data-mp="huxrrr3a8nwo">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-205" data-mp="hsl2esv73b9l">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-navy text-white" data-id="element-206" data-mp="mtsa6rxc8ag9">
            <HeartHandshakeIcon className="h-5 w-5" aria-hidden="true" data-id="element-207" data-mp="qu2r2zmo4l9w" />
          </span>
          <span className="font-display text-xl font-bold text-navy" data-id="element-208" data-mp="vnnejxqmxwuu">
            Calm Response 5<sup className="text-xs" data-id="element-209" data-mp="10kdw6pi390id">™</sup>
          </span>
          <span className="rounded-full border border-navy/10 bg-white px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-teal-dark" data-id="element-210" data-mp="15kif0m6gy7br">
            By Laura Mendes
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-display text-[32px] font-bold leading-[1.08] text-navy sm:text-5xl md:text-[62px]" data-id="element-211" data-mp="9nj8e5z3849k">
          The 5-step crisis response system for parents who don't know what to do{' '}
          <em className="text-coral" data-id="element-212" data-mp="3vu951c65s4gs">when a meltdown starts</em>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-213" data-mp="3rtp6c45xsssj">
          Does your child have <strong className="text-navy" data-id="element-214" data-mp="setzoo8q6j1z">meltdowns, emotional outbursts, sensory overload</strong>, or
          moments when it feels impossible to calm them down? I've created{' '}
          <strong className="text-navy" data-id="element-215" data-mp="io9130t1xej2">Calm Response 5™</strong> to help you know what to do when those moments happen.
        </p>

        <img src={IMAGES.mainMockup} alt="Calm Response 5™ — 6 volumes, SOS cards and 5 bonuses" className="-mx-3 mt-6 w-[calc(100%+24px)] max-w-none sm:mx-auto sm:w-full sm:max-w-3xl" data-id="element-216" data-mp="elujek14cktd" />

        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-navy sm:text-xl" data-id="element-217" data-mp="16cs9dgc3prb5">
          In <strong data-id="element-218" data-mp="30mfjlybkm3ht">less than 10 minutes</strong>, I'll teach you my simple 5-step response system so you can{' '}
          <strong className="text-teal-dark" data-id="element-219" data-mp="35n392fk5ic9x">stop guessing</strong> and have a clear next step when your child becomes
          overwhelmed.
        </p>

        <div className="mt-8" data-id="element-220" data-mp="2vufbvjp9e6ao">
          <CTAButton id="hero-cta" label="Yes, I want to know what to do when a meltdown starts" microcopy={DEFAULT_MICROCOPY} data-id="element-221" data-mp="2vtmfncnxez6s" />
        </div>
        <div className="mt-8" data-id="element-222" data-mp="2mu93udcbxyiw">
          <Countdown data-id="element-223" data-mp="2mvk628q4my7w" />
        </div>
      </div>
    </header>;
}